import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
  };
};

export const getSuppliers = async (filter) => {
  const response = await axios.post(`${BASE_URL}/api/Supplier/get`, filter, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const saveSupplier = async (supplier) => {
  const response = await axios.post(`${BASE_URL}/api/Supplier/save`, supplier, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// API to search suppliers with pagination and search text
export const searchSuppliers = async (searchText, page = 1, pageSize = 20) => {
  try {
    console.log('🌐 API Call - searchSuppliers:', {
      url: `${BASE_URL}/api/Supplier/search`,
      payload: { searchText, page, pageSize, activeOnly: true },
      headers: getAuthHeader()
    });
    
    const response = await axios.post(`${BASE_URL}/api/Supplier/search`, {
      searchText: searchText,
      page: page,
      pageSize: pageSize,
      activeOnly: true
    }, {
      headers: getAuthHeader(),
    });
    
    console.log('🌐 API Response - searchSuppliers:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API Error - searchSuppliers:", error);
    console.error("❌ Error details:", {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
};

export const exportSuppliersToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Supplier/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SupplierReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting suppliers:", error);
    throw error;
  }
}; 